
define('text!modules/targeting/digital/templates/panel.html',[],function () { return '<div class="w-box w-DigitalTargeting">\n\t<div class="w-body w-panel-body"><!-- The Search & browse views render here--></div>\n\t<div class="w-foot">{{>footer}}</div>\n</div>\n';});

